import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

export const workOrderSchema = defineSchema({ fields: {} });

export const exampleWorkOrderSchemaInstance: SchemaInstance<
  typeof workOrderSchema
> = {};
